import { render } from "./DonutChartWebsites.vue?vue&type=template&id=43166773&scoped=true"
import script from "./DonutChartWebsites.vue?vue&type=script&lang=js"
export * from "./DonutChartWebsites.vue?vue&type=script&lang=js"

import "./DonutChartWebsites.vue?vue&type=style&index=0&id=43166773&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43166773"]])

export default __exports__